(function (Drupal) {
  Drupal.behaviors.nettieMap = {
    attach: function (context, settings) {
      const mapTab = context.querySelector('.tabulators .item[data-item="map"]');
      const listTab = context.querySelector('.tabulators .item[data-item="list"]');
      const listView = context.querySelector('.tab-view.list');
      const mapView = context.querySelector('.tab-view.map');
      const loadMapButton = context.querySelector('.load-map-button');
      const mapLoader = context.querySelector('.map-loader');

      // Funktion zum Aktualisieren der URL mit erhaltenen Parametern
      function updateUrlParams(newParams) {
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);

        // Bestehende Parameter beibehalten, neue hinzufügen/überschreiben
        Object.entries(newParams).forEach(([key, value]) => {
          params.set(key, value);
        });

        url.search = params.toString();
        window.location.href = url.toString(); // Seiten-Reload
      }

      // Tab-Logik für Liste
      if (listTab && !listTab.dataset.listenerAdded) {
        listTab.dataset.listenerAdded = 'true';
        listTab.addEventListener('click', function () {
          if (listView && mapView) {
            listView.classList.add('active');
            mapView.classList.remove('active');
            listTab.dataset.active = 'true';
            mapTab.dataset.active = 'false';
            document.cookie = 'activeNettieFilterTab=list; path=/; max-age=86400';
          }
        });
      }

      // Tab-Logik für Karte
      if (mapTab && !mapTab.dataset.listenerAdded) {
        mapTab.dataset.listenerAdded = 'true';
        mapTab.addEventListener('click', function () {
          if (listView && mapView) {
            listView.classList.remove('active');
            mapView.classList.add('active');
            listTab.dataset.active = 'false';
            mapTab.dataset.active = 'true';
            document.cookie = 'activeNettieFilterTab=map; path=/; max-age=86400';
          }
        });
      }

      // Button-Logik für Karte laden (einmaliger Reload)
      if (loadMapButton && !loadMapButton.dataset.listenerAdded) {
        loadMapButton.dataset.listenerAdded = 'true';
        loadMapButton.addEventListener('click', function (e) {
          e.preventDefault();
          document.cookie = 'mapIsLoaded=true; path=/; max-age=86400';
          document.cookie = 'activeNettieFilterTab=map; path=/; max-age=86400';

          // Klaro-Cookie für Google Maps setzen
          if (typeof Cookies === 'function' && Cookies.get('klaro')) {
            const klaroCookies = Cookies.get('klaro');
            const klaroObj = klaroCookies ? JSON.parse(klaroCookies) : {};
            klaroObj.google_maps = true;
            Cookies.set('klaro', JSON.stringify(klaroObj), { path: '/', maxAge: 86400 });
          }

          // Loader anzeigen
          if (mapLoader) {
            mapLoader.style.opacity = '1';
            mapLoader.style.transition = 'opacity 0.3s ease';
          }

          // Reload mit bestehenden Filtern + load_map
          updateUrlParams({ load_map: '1' });
        });
      }
    }
  };
})(Drupal);